// extracted by mini-css-extract-plugin
export default {"package-intro":"packageIntroduce_package-intro__mRxga"};